import styled, { css } from 'styled-components';

import {
  grey1,
  grey10,
  grey9,
  purple7,
} from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { spacing20 } from 'approot/shared/styles/spacing.style';
import {
  ARROW_ALIGNMENT_BOTTOM,
  ARROW_ALIGNMENT_CENTRE,
  ARROW_ALIGNMENT_LEFT,
  ARROW_ALIGNMENT_RIGHT,
  ARROW_ALIGNMENT_TOP,
  POSITION_BOTTOM,
  POSITION_LEFT,
  POSITION_RIGHT,
  POSITION_TOP,
  BORDER_STYLE_BOX,
  BORDER_STYLE_THOUGHT,
} from 'global/constants';
import Richtext from 'approot/shared/richtext/richtext';
import { richtextCommonCss } from 'approot/shared/richtext/richtext.style';
import {
  InfoBoxProps,
  baseInfoBoxSpeech,
  boxShadowSpeech,
} from './info-box-speech.style';

const baseInfoBoxThoughtCss = css<InfoBoxProps>`
  border-radius: ${rem(32)};
  ${({ $alignment, $position }) =>
    $alignment &&
    css`
      &:before {
        content: '';
        background-color: ${grey1};
        position: absolute;
        height: ${rem(4)};
        width: ${rem(36)};
        z-index: 1;

        ${$position === POSITION_BOTTOM &&
        `
          bottom: -${rem(2)};
          left: calc(50% - ${rem(18)});
        `}

        ${$position === POSITION_TOP &&
        `
          top: -${rem(2)};
          left: calc(50% - ${rem(18)});
        `}

        ${$position === POSITION_RIGHT &&
        `
          right: -${rem(2)};
          top: calc(50% - ${rem(18)});
          height: ${rem(36)};
          width: ${rem(4)};
        `}

        ${$position === POSITION_LEFT &&
        `
          left: -${rem(2)};
          top: calc(50% - ${rem(18)});
          height: ${rem(36)};
          width: ${rem(4)};
        `}

        ${$alignment === ARROW_ALIGNMENT_LEFT &&
        `
          left: ${rem(32)};
        `}

        ${$alignment === ARROW_ALIGNMENT_RIGHT &&
        `
          left: auto;
          right: ${rem(32)};
        `}

        ${$alignment === ARROW_ALIGNMENT_TOP &&
        `
          top: ${rem(22)};
        `}

        ${$alignment === ARROW_ALIGNMENT_BOTTOM &&
        `
          bottom: ${rem(22)};
          top: auto;
        `}
      }

      &:after {
        content: '';
        position: absolute;
        background-color: ${grey1};
        border: 2px solid ${purple7};
        border-radius: ${rem(20)};

        ${$alignment === ARROW_ALIGNMENT_LEFT &&
        `
          left: ${rem(30)};
          right: auto;
        `}

        ${$alignment === ARROW_ALIGNMENT_RIGHT &&
        `
          right: ${rem(30)};
          left: auto;
        `}

        ${$alignment === ARROW_ALIGNMENT_CENTRE &&
        `
          left: calc(50% - ${rem(spacing20)});
          right: auto;
        `}

        ${$alignment === ARROW_ALIGNMENT_CENTRE &&
        ($position === POSITION_TOP || $position === POSITION_BOTTOM) &&
        `
          left: calc(50% - ${rem(spacing20)});
          right: auto;
        `}

        ${$alignment === ARROW_ALIGNMENT_CENTRE &&
        ($position === POSITION_LEFT || $position === POSITION_RIGHT) &&
        `
          top: calc(50% - ${rem(spacing20)});
        `}

        ${$alignment === ARROW_ALIGNMENT_TOP &&
        `
          top: ${rem(spacing20)};
          bottom: auto;
        `}

        ${$alignment === ARROW_ALIGNMENT_BOTTOM &&
        `
          bottom: ${rem(spacing20)};
          top: auto;
        `}

        ${$position === POSITION_TOP &&
        `
          top: -${rem(20)};
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          border-bottom: none;
          height: ${rem(20)};
          width: ${rem(40)};
        `}

        ${$position === POSITION_BOTTOM &&
        `
          bottom: -${rem(20)};
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          border-top: none;
          height: ${rem(20)};
          width: ${rem(40)};
        `}

        ${$position === POSITION_LEFT &&
        `
          left: -${rem(spacing20)};
          right: auto;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-right: none;
          height: ${rem(40)};
          width: ${rem(20)};
        `}

        ${$position === POSITION_RIGHT &&
        `
          right: -${rem(20)};
          left: auto;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          border-left: none;
          height: ${rem(40)};
          width: ${rem(20)};
        `}
      }
    `}
`;

export const InfoBoxThought = styled(Richtext)<InfoBoxProps>`
  display: flex;
  justify-content: ${({ $textAlignment }) => $textAlignment};

  .ProseMirror {
    ${baseInfoBoxSpeech}
    ${baseInfoBoxThoughtCss}
    background-color: ${grey1};
    max-width: ${({ $width }) => $width || 100}%;
    width: 100%;

    &:hover,
    &:focus {
      border-width: 2px;
    }

    &:hover {
      border: 2px solid ${purple7};
      &:after {
        border-color: ${purple7};
      }
    }
    &:focus {
      border: 2px solid ${grey10};
      box-shadow:
        0 0 0 1px ${grey9},
        ${boxShadowSpeech};
      &:after {
        border-color: ${grey10};
      }
    }
  }
`;

export const InfoBoxThoughtView = styled.div<InfoBoxProps>`
  ${richtextCommonCss}
  ${baseInfoBoxSpeech}

  max-width: ${({ $width }) => $width || 100}%;
  width: 100%;

  ${({ $borderStyle }) =>
    $borderStyle === BORDER_STYLE_BOX &&
    css`
      border-radius: ${rem(borderRadius8)};
    `};

  ${({ $borderStyle }) =>
    $borderStyle === BORDER_STYLE_THOUGHT &&
    css<InfoBoxProps>`
      ${baseInfoBoxThoughtCss}
    `};
`;
